import { render, staticRenderFns } from "./CatBrand.vue?vue&type=template&id=5dde52f6&"
import script from "./CatBrand.vue?vue&type=script&lang=js&"
export * from "./CatBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports